import { DropdownPopOverContent } from "./content";
import { DropdownPopOverFooter } from "./footer";
import { DropdownPopOverHeader } from "./header";
import { DropdownPopOver as _Popover } from "./pop-over";

export const PopOver = Object.assign(_Popover, {
  Content: DropdownPopOverContent,
  Header: DropdownPopOverHeader,
  Footer: DropdownPopOverFooter,
});
